import { render, staticRenderFns } from "./topPage.vue?vue&type=template&id=523c06da&scoped=true"
import script from "./topPage.vue?vue&type=script&lang=js"
export * from "./topPage.vue?vue&type=script&lang=js"
import style0 from "./topPage.vue?vue&type=style&index=0&id=523c06da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c06da",
  null
  
)

export default component.exports